module.exports = __webpack_public_path__ + "static/logo-starmen-d00b04dbf3af6f226c44cc2e10edf384.png";